import React from "react";
import { useAppSelector } from "../../../../store/hooks";
import InvalidBarcodeSvg from "../../../../assets/invalid-barcode-svg.svg"

const InvalidBarcodeModal = ({ isOpen, onClose }) => {
  const { isPartsURL, isAccessoriesURL } = useAppSelector((state) => state.domain);
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="invalid-barcode-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-icon-invalid-barcode" style={{ marginBottom: "10px" }}>
          <img src={InvalidBarcodeSvg} alt="Invalid Barcode" />
        </div>

        <h2 className="modal-title-invalid-barcode">Invalid Barcode</h2>
        <p className="modal-message-invalid-barcode">
          No product found for the scanned barcode. Please try again or
          check the code.
        </p>
        <button className={isPartsURL ? "modal-ok-btn-parts" : isAccessoriesURL ? "modal-ok-btn-acc" : "modal-ok-btn"} onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default InvalidBarcodeModal;
